import {
  Flex,
  FormControl,
  FormControlOptions,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Text,
} from "@chakra-ui/react";
import * as React from "react";
import { FieldError } from "react-hook-form";
import { FaQuestion } from "react-icons/fa6";

type FieldWrapperProps = {
  children: React.ReactNode;
  label?: string;
  error?: FieldError | undefined;
  chakraOptions?: FormControlOptions;
  labelPosition?: "inline" | "top" | "bottom";
  isRequired?: boolean;
  openHelpModal?: () => void;
  htmlFor?: string;
};

export type FieldWrapperPassThroughProps = Omit<FieldWrapperProps, "children">;

export const FieldWrapper = (props: FieldWrapperProps) => {
  const {
    children,
    label,
    error = undefined,
    chakraOptions,
    labelPosition,
    isRequired = true,
    openHelpModal = undefined,
    htmlFor = undefined,
  } = props;

  return (
    <FormControl
      my={labelPosition === "inline" ? 2 : 5}
      isInvalid={typeof error !== "undefined"}
      {...chakraOptions}
    >
      <Flex
        direction={
          labelPosition === "inline"
            ? "row"
            : labelPosition === "bottom"
              ? "column-reverse"
              : "column"
        }
      >
        {label && (
          <Flex>
            <FormLabel
              fontWeight="bold"
              fontSize="1rem"
              alignSelf={labelPosition === "inline" ? "center" : "start"}
              marginRight={1}
              htmlFor={htmlFor}
            >
              <Flex alignContent="start">
                <Text as="span">
                  {label}
                  {isRequired && (
                    <Text as="span" marginLeft={1} color="red">
                      *
                    </Text>
                  )}
                  {openHelpModal && (
                    <IconButton
                      aria-label="question help"
                      isRound
                      marginX={0}
                      icon={<FaQuestion />}
                      fontSize=".75rem"
                      minWidth="1rem"
                      h="1rem"
                      variant="primary"
                      marginTop={1}
                      onClick={openHelpModal}
                    />
                  )}
                </Text>
              </Flex>
            </FormLabel>
          </Flex>
        )}
        {children}
      </Flex>
      {error?.message && (
        <FormErrorMessage fontWeight="bold">{error?.message}</FormErrorMessage>
      )}
    </FormControl>
  );
};
